import React from 'react';
import { Input, Modal, Radio, TimePicker, Button } from 'antd';
import moment from 'moment';

const RadioGroup = Radio.Group;

export default class AlarmSetting extends React.Component {
  componentWillUnmount() {
    this.props.dispatch({ type: 'monitor/setConfig', configData: {} });
  }

  render() {
    const { intl, monitor } = this.props;
    const { configData } = monitor;
    return (
      <div className="panel-monitor">
        {/*<div className="alarm-title">*/}
        {/*<span>{intl.formatMessage({id: 'monitor_alarm_set'})}</span>*/}
        {/*</div>*/}
        <div className="alarm-body">
          <div className="alarm-count">
            <div className="alarm-count-title">
              <span>
                {intl.formatMessage({ id: 'monitor_alarm_frequency' })}
              </span>
            </div>
            <div className="alarm-count-body">
              <RadioGroup
                value={configData.type || 1}
                onChange={e =>
                  this.onChange(
                    Object.assign({}, configData, { type: e.target.value })
                  )
                }
              >
                <Radio value={1}>
                  {intl.formatMessage({ id: 'monitor_alarm_every_set' })}
                </Radio>
                &nbsp;&nbsp;&nbsp;
                <Radio value={2}>
                  {intl.formatMessage({ id: 'monitor_alarm_follow_set' })}
                </Radio>
              </RadioGroup>
              {Number(configData.type) === 2 && (
                <div className="alarm-count-setting">
                  {intl.formatMessage({ id: 'monitor_alarm_every' })}
                  <Input
                    style={{ width: 60 }}
                    value={configData.intervalTime || ''}
                    onChange={e => {
                      let value = e.target.value;
                      const reg = /^[1-9]\d*$/;
                      if (
                        (reg.test(value) || value === '') &&
                        value.length <= 3
                      ) {
                        this.onChange(
                          Object.assign({}, configData, { intervalTime: value })
                        );
                      }
                    }}
                  />
                  {intl.formatMessage({ id: 'monitor_alarm_minutes' })}
                  <Input
                    style={{ width: 80 }}
                    value={configData.frequency || ''}
                    onChange={e => {
                      let value = e.target.value;
                      const reg = /^[1-9]\d*$/;
                      if (
                        (reg.test(value) || value === '') &&
                        value.length <= 2
                      ) {
                        this.onChange(
                          Object.assign({}, configData, { frequency: value })
                        );
                      }
                    }}
                  />
                  {intl.formatMessage({ id: 'monitor_alarm_times' })}
                </div>
              )}
            </div>
          </div>
          <div className="alarm-email">
            <div className="alarm-email-title">
              <span>{intl.formatMessage({ id: 'monitor_alarm_mailbox' })}</span>
            </div>
            <div className="alarm-email-body">
              <Input
                className="alarm-email-input"
                value={configData.emails || ''}
                placeholder={intl.formatMessage({
                  id: 'monitor_alarm_input_rule'
                })}
                onChange={e => {
                  let value = e.target.value;
                  if (value.length <= 250) {
                    this.onChange(
                      Object.assign({}, configData, { emails: value })
                    );
                  }
                }}
              />
            </div>
          </div>
          <div className="alarm-email">
            <div className="alarm-email-title">
              <span>{intl.formatMessage({ id: 'monitor_time' })}</span>
            </div>
            <div className="alarm-email-body alarm-time">
              <TimePicker
                value={moment(
                  configData.monitorStartTime || '00:00:00',
                  'HH:mm:ss'
                )}
                onChange={e => {
                  this.onChange(
                    Object.assign({}, configData, {
                      monitorStartTime: e.format('HH:mm:ss')
                    })
                  );
                }}
              />{' '}
              ~{' '}
              <TimePicker
                value={moment(
                  configData.monitorEndTime || '00:00:00',
                  'HH:mm:ss'
                )}
                onChange={e => {
                  this.onChange(
                    Object.assign({}, configData, {
                      monitorEndTime: e.format('HH:mm:ss')
                    })
                  );
                }}
              />
            </div>
          </div>
          <div className="alarm-apply">
            <Button
              // className="alarm-apply-btn"
              type="primary"
              onClick={() => this.apply(configData)}
            >
              {intl.formatMessage({ id: 'monitor_alarm_apply' })}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  onChange = obj => {
    this.props.dispatch({ type: 'monitor/setConfig', configData: obj });
  };

  apply = config => {
    if (!config.type) {
      config.type = 1;
    }
    if (!config.intervalTime) {
      config.intervalTime = 1;
    }
    if (!config.frequency) {
      config.frequency = 1;
    }
    if (!config.intervalTime || Number(config.intervalTime) === 0) {
      Modal.warning({
        content: this.props.intl.formatMessage({
          id: 'monitor_alarm_intervalTime_error'
        })
      });
      return;
    }
    if (!config.frequency || Number(config.frequency) === 0) {
      Modal.warning({
        content: this.props.intl.formatMessage({
          id: 'monitor_alarm_frequency_error'
        })
      });
      return;
    }
    if (this.verifyEMail(config.emails)) {
      Modal.warning({
        content: this.props.intl.formatMessage({
          id: 'monitor_alarm_email_error'
        })
      });
      return;
    }
    this.props.dispatch({ type: 'monitor/setAlarmConfig', config: config });
  };

  verifyEMail = emails => {
    let result = true;
    if (emails) {
      result = false;
      let emailList = emails.split(';');
      let reg = new RegExp(
        '^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$'
      );
      emailList.map(email => {
        if (!reg.test(email)) result = true;
      });
    }
    return result;
  };
}



// WEBPACK FOOTER //
// ./src/components/monitor/AlarmSetting.js